// SCHERMATA DI FINE PARTITA
//
// Prima questo pannello viveva in `public/index.html` e la scena di Phaser lo
// pilotava a mano: `document.getElementById('fomo-popup')`, testi riscritti con
// `innerText`, colori impostati con `style.color`, paragrafi creati al volo con
// `createElement` e pulsanti agganciati con `.onclick`.
//
// Funzionava, ma legava il motore di gioco alla struttura dell'HTML: bastava
// rinominare una classe o spostare un nodo per rompere il gioco **in silenzio**,
// perche' il codice controllava `if (popup && amountSpan)` e, non trovandoli, si
// limitava a non mostrare niente. Inoltre i nodi erano fuori da React e
// sopravvivevano all'uscita dalla partita: capitava di vedere il pannello di una
// morte precedente ricomparire sopra la lobby.
//
// Adesso la scena non tocca piu' il DOM: emette un evento con i dati della
// partita conclusa (`vexel_game_over`) e questo componente decide cosa mostrare.
// Le classi CSS sono rimaste le stesse (`index.css`), quindi l'aspetto non cambia.

import React, { useEffect, useState } from 'react';

const TITOLO_MORTE = '⚠️ UNREALIZED GAINS DETECTED';
const TITOLO_CASHOUT = '✅ SUCCESSFUL EXTRACTION';

// La skin si sblocca sopravvivendo un minuto: la assegna il server, qui lo
// annunciamo soltanto (la soglia deve restare allineata a `survive_60s` nel
// catalogo missioni del server).
const SOGLIA_SBLOCCO_MS = 60000;

const GameOverPopup = () => {
  const [esito, setEsito] = useState(null);

  useEffect(() => {
    const mostra = (e) => setEsito(e.detail || {});
    window.addEventListener('vexel_game_over', mostra);
    return () => window.removeEventListener('vexel_game_over', mostra);
  }, []);

  if (!esito) return null;

  const cashout = esito.reason === 'CASHOUT_SUCCESS';
  const importo = cashout ? esito.finalPayout : esito.loss;

  const tornaInLobby = () => {
    setEsito(null);
    window.dispatchEvent(new CustomEvent('return_to_landing'));
  };

  const condividi = () => {
    const testo = encodeURIComponent(
      `⚠️ I just missed out on ${importo} $SOL because I was playing the FREE BETA of VEXEL.\n\n` +
      `Time to stop playing games. It's time to PLAY FOR REAL. 🐍💹\n\n@VexelProtocol #VEXEL #Solana`
    );
    window.open(`https://twitter.com/intent/tweet?text=${testo}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="fomo-overlay" style={{ display: 'flex', zIndex: 9999 }}>
      <div className="fomo-modal">
        {cashout ? (
          <h2 style={{ color: '#FFD700', textShadow: '0 0 10px #FFD700' }}>{TITOLO_CASHOUT}</h2>
        ) : (
          <h2 className="glitch-text" data-text={TITOLO_MORTE}>{TITOLO_MORTE}</h2>
        )}

        {cashout ? (
          <p>
            You successfully extracted with{' '}
            <span className="neon-amount" style={{ color: '#FFD700' }}>{esito.finalPayout}</span> value!
          </p>
        ) : (
          <p>
            If you were playing in Ranked Mode, you would have just won{' '}
            <span className="neon-amount">{esito.loss}</span>
          </p>
        )}

        {cashout ? (
          <p className="fomo-status" style={{ color: '#FFD700', textShadow: '0 0 5px #FFD700' }}>
            {esito.rawTax > 0 ? (
              <>
                STATUS: SECURED
                <br />
                <small style={{ color: '#aaa' }}>(Profit Tax Deducted: {esito.taxPaid})</small>
              </>
            ) : (
              'STATUS: SECURED (No Tax - Break Even)'
            )}
            {/* Se l'ingresso era gratuito il payout non diventa denaro. Dirlo
                qui evita che il giocatore vada a cercare nel saldo una vincita
                che non e' mai stata accreditata. */}
            {esito.credited === 0 && (
              <>
                <br />
                <small style={{ color: '#aaa' }}>
                  Partita gratuita: nessun accredito sul saldo.
                </small>
              </>
            )}
          </p>
        ) : (
          <p className="fomo-status" style={{ color: '#ff0055', textShadow: '0 0 5px #ff0055' }}>
            CAUSE OF DEATH: {esito.reason}
          </p>
        )}

        {esito.survivalTime >= SOGLIA_SBLOCCO_MS && (
          <p className="fomo-unlock" style={{ color: '#39FF14', textShadow: '0 0 5px #39FF14' }}>
            🔓 UNLOCKED: BINARY SNAKE SKIN! (Survived &gt; 60s)
          </p>
        )}

        <div className="fomo-actions">
          {/* Il ranked a pagamento non esiste ancora: finche' il profilo prezzi e'
              "free" questo pulsante riporta in lobby come gli altri. Quando ci
              saranno le arene a pagamento diventera' la scorciatoia per
              rientrare direttamente nel tier scelto. */}
          <button className="btn-neon-glitch" onClick={tornaInLobby}>PLAY FOR REAL</button>
          <button className="btn-ghost" style={{ color: '#1DA1F2', borderColor: '#1DA1F2' }} onClick={condividi}>
            SHARE ON X 𝕏
          </button>
          <button className="btn-ghost" onClick={tornaInLobby}>
            {cashout ? 'PLAY AGAIN' : 'STAY POOR'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameOverPopup;
